import React from "react";
import { Modal, UnorderedList, ListItem, Button } from "@carbon/react";

const MapBlocker = ({ missing = [], hints = [], onRetry }) => {
  return (
    <Modal
      open
      passiveModal
      size="lg"
      modalHeading="No puedes usar el mapa todavía"
      aria-label="Requisitos para usar el mapa"
    >
      <p>Faltan estos requisitos de configuración:</p>
      <UnorderedList>
        {missing.map((m, i) => (
          <ListItem key={i}>{m}</ListItem>
        ))}
      </UnorderedList>

      {hints.length > 0 && (
        <>
          <p style={{ marginTop: 16 }}>Sugerencias:</p>
          <UnorderedList>
            {hints.map((h, i) => (
              <ListItem key={i}>{h}</ListItem>
            ))}
          </UnorderedList>
        </>
      )}

      <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
        <Button kind="primary" onClick={onRetry}>Reintentar</Button>
      </div>
    </Modal>
  );
};

export default MapBlocker;
